var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05957 1.5127C6.92334 0.642935 9.07666 0.642935 10.9404 1.5127L11.0713 1.57324C13.3761 2.64891 14.7834 5.03049 14.6143 7.56836C14.5016 9.25651 13.6993 10.8238 12.3965 11.9033L8.59863 15.0508C8.25157 15.3383 7.74843 15.3383 7.40137 15.0508L3.60352 11.9033C2.3007 10.8238 1.4984 9.25651 1.38574 7.56836C1.21655 5.03049 2.62387 2.64891 4.92871 1.57324L5.05957 1.5127Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4261482f3b24d9f80ed7f549245fcedd.svg";
export { ForwardRef as ReactComponent };